'use client';

import { EPlatform } from '@/utils/enums/platform-enum';
import React from 'react';
import dynamic from 'next/dynamic';
import CategoryNavBig from './components/CategoryNavBig/CategoryNavBig';

const BlogArticle = dynamic(() => import('./components/BlogArticle/BlogArticle'), {
  ssr: false,
  loading: () => <div className="h-[200px] animate-pulse bg-[#f5f5f5]" />,
});
const BrandImage = dynamic(() => import('./components/BrandImage/BrandImage'), {
  ssr: false,
  loading: () => <div className="h-[100px] animate-pulse bg-[#f5f5f5]" />,
});
const CategoryNavShape = dynamic(() => import('./components/CategoryNavShape/CategoryNavShape'), {
  ssr: true,
});
const CategoryNavSmall = dynamic(() => import('./components/CategoryNavSmall/CategoryNavSmall'), {
  ssr: true,
});
const FivePicSwiper = dynamic(() => import('./components/FivePicSwiper/FivePicSwiper'), {
  ssr: true,
});
const HeroBanner = dynamic(() => import('./components/HomeBanner/HomeBanner'), { ssr: true });
const MultiSwipe = dynamic(() => import('./components/MultiSwipe/MultiSwipe'), { ssr: true });
const ProductList = dynamic(() => import('./components/ProductList'), { ssr: true });
const StyleHub = dynamic(() => import('./components/StyleHub/StyleHub'), {
  ssr: false,
  loading: () => <div className="h-[300px] animate-pulse bg-[#f5f5f5]" />,
});
const WaterFall = dynamic(() => import('./components/WaterFall/WaterFall'), {
  ssr: false,
  loading: () => <div className="h-[400px] animate-pulse bg-[#f5f5f5]" />,
});

interface HomePageBlockItem {
  id?: number;
  component_id?: string;
  jump_target?: any[];
  [key: string]: any;
}

interface HomeSectionRendererProps {
  listData: HomePageBlockItem[];
  deviceType: EPlatform;
  onTrack?: (eventParams: any) => void;
  onExpTrack?: (eventParams: any) => void;
  onValidExpTrack?: (eventParams: any) => void;
  homeListData?: HomePageBlockItem[];
}

const COMPONENT_MAP: Record<string, React.ComponentType<any>> = {
  swipeImage: HeroBanner,
  categoryNavSmall: CategoryNavSmall,
  categoryNavShape: CategoryNavShape,
  categoryNavBig: CategoryNavBig,
  styleHub: StyleHub,
  multiSwipe: MultiSwipe,
  multiSwipeSecond: FivePicSwiper,
  blogArticle: BlogArticle,
  brandImage: BrandImage,
  regularList: ProductList,
  waterFall: WaterFall,
};

export default function HomeSectionRenderer({
  listData,
  deviceType = EPlatform.WEB,
  onTrack,
  onExpTrack,
  onValidExpTrack,
  homeListData = [],
}: HomeSectionRendererProps) {
  const isMobile = deviceType === EPlatform.WAP;

  return (
    <>
      {listData.map((item, index) => {
        if (!item.component_id) return null;

        const Component = COMPONENT_MAP[item.component_id];
        if (!Component) return null;

        return (
          <div key={item.id || `section-${index}`} className="index-box">
            <Component
              moduleIndex={index}
              indexData={item}
              homeListData={homeListData}
              isMobile={isMobile}
              onTrack={onTrack}
              onExpTrack={onExpTrack}
              onValidExpTrack={onValidExpTrack}
            />
          </div>
        );
      })}
    </>
  );
}
